import { Controller } from "@hotwired/stimulus"

// Marks the element when its viewport has more content off either edge, and scrolls it by a page.
export default class extends Controller {
  static targets = ["viewport"]
  static classes = ["moreStart", "moreEnd"]

  connect() {
    this.update = this.update.bind(this)
    this.viewportTarget.addEventListener("scroll", this.update, { passive: true })
    // Also fires when a hidden pill filter section is shown, since the width goes from zero.
    this.resizeObserver = new ResizeObserver(this.update)
    this.resizeObserver.observe(this.viewportTarget)
    this.update()
  }

  disconnect() {
    this.viewportTarget.removeEventListener("scroll", this.update)
    this.resizeObserver.disconnect()
  }

  scrollStart() {
    this.scrollByPage(-1)
  }

  scrollEnd() {
    this.scrollByPage(1)
  }

  scrollByPage(direction) {
    const viewport = this.viewportTarget
    viewport.scrollBy({ left: direction * viewport.clientWidth * 0.8 })
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewportTarget
    // scrollLeft is fractional on zoomed or high-DPI screens
    this.element.classList.toggle(this.moreStartClass, scrollLeft > 1)
    this.element.classList.toggle(this.moreEndClass, scrollLeft + clientWidth < scrollWidth - 1)
  }
}
